import React, { useState, useEffect } from 'react';

interface OtpScreenProps {
  loading: boolean;
  defaultCode?: string;
  onSubmit: (code: string) => void;
  onBack: () => void;
}

export const OtpScreen: React.FC<OtpScreenProps> = ({ loading, defaultCode = '', onSubmit, onBack }) => {
  const [code, setCode] = useState(defaultCode);

  useEffect(() => {
    if (defaultCode) {
      setCode(defaultCode);
    }
  }, [defaultCode]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(code);
  };

  return (
    <div className="pwa-auth-container">
      <h1 className="pwa-auth-title">ENTER OTP CODE</h1>
      <p className="pwa-auth-subtitle">A verification passcode was sent to your phone number</p>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="pwa-auth-input"
          style={{ letterSpacing: '8px', textAlign: 'center', fontSize: '24px', fontWeight: '800' }}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          maxLength={6}
          placeholder="Code"
          required
        />

        <button type="submit" disabled={loading} className="pwa-primary-btn">
          {loading ? 'VERIFYING...' : 'VERIFY'}
        </button>

        <button type="button" onClick={onBack} className="pwa-secondary-btn">
          BACK
        </button>
      </form>
    </div>
  );
};
